import React, { useEffect, useState } from 'react';
import styled from 'styled-components/native';
import { useUserContext } from '../context/UserContext';
import { useUpdateUser } from '../hooks/user/useUpdateUser';
import ImageActionSheet from './modals/ImageActionSheet';
import Avatar from './Avatar';

const StyledAvatarButton = styled.TouchableOpacity`
  position: relative;
`;

const ProfilePhoto: React.FC = () => {
  const { user, setUser } = useUserContext();
  const [openActionSheet, setOpenActionSheet] = useState(false);
  const [uploading, setUploading] = useState(false);
  const { updatedUser, updateUser, updateUserError, clearUpdatedUser } =
    useUpdateUser();
  useEffect(() => {
    if (updateUserError) {
      alert(updateUserError.message);
    }
  }, [updateUserError]);

  useEffect(() => {
    if (updatedUser) {
      setUser(updatedUser);
      clearUpdatedUser;
    }
  }, [clearUpdatedUser, setUser, updatedUser]);

  return (
    <>
      <StyledAvatarButton
        activeOpacity={0.7}
        onPress={() => {
          if (uploading) return;
          setOpenActionSheet(true);
        }}
      >
        <Avatar size='hero' user={user} />
      </StyledAvatarButton>
      <ImageActionSheet
        visible={openActionSheet}
        uploadPath='files/presign/user-image'
        presignBody={[
          { size: 'large' },
          { size: 'medium' },
          { size: 'thumbnail' }
        ]}
        resize={[1024, 512, 256]}
        selectText='Take new profile photo'
        captureText='Choose an existing photo'
        onUploadedImages={([
          largeImageUpload,
          mediumImageUpload,
          thumbnailImageUpload
        ]) => {
          setOpenActionSheet(false);
          // update user after all images are uploaded
          updateUser({
            largeUrl: largeImageUpload?.presignedResult?.destinationUrl,
            mediumUrl: mediumImageUpload?.presignedResult?.destinationUrl,
            thumbnailUrl: thumbnailImageUpload?.presignedResult?.destinationUrl
          });
        }}
        onUploading={uploading => setUploading(uploading)}
        onUploadError={error => alert(error.message)}
        onClose={() => setOpenActionSheet(false)}
      />
    </>
  );
};

export default ProfilePhoto;
